module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "activityPage"
    }
  }, [(_vm.activityStatus !== 404) ? _c('Background-Image', {
    attrs: {
      "color": "#F8F6EE",
      "opacity": "1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activityStatus == 404) ? _c('Background-Image', {
    attrs: {
      "url": "albufeira.jpg",
      "color": "#F8F6EE"
    }
  }) : _vm._e(), _vm._v(" "), _c('Navigation', {
    attrs: {
      "page": "activity",
      "showUserNav": true
    }
  }), _vm._v(" "), (_vm.showCalendarOnTop) ? _c('div', {
    staticClass: "calendarOnTop"
  }, [_c('ActivityCalendar', {
    staticClass: "activityCalendar",
    attrs: {
      "activityId": _vm.activity.id,
      "showCloseButton": true
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activityStatus == 404) ? _c('div', {
    staticClass: "container-fluid m-t-6",
    attrs: {
      "id": "status404"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "NotFoundCard col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.t('Activity not found')))]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.t('Sorry, the activity you were looking for was not found.')))]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": '/' + _vm.language
    }
  }, [_vm._v(_vm._s(_vm.t('Return to the Homepage')))])], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.activity.translations && _vm.activityStatus == 200) ? _c('div', {
    staticClass: "container-fluid"
  }, [(!_vm.activity.approved) ? _c('div', {
    staticClass: "row m-t-4"
  }, [_c('div', {
    staticClass: "col-xs-12 text-xs-center"
  }, [_c('Card', [_c('div', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.t('Preview')))]), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_vm._v(_vm._s(_vm.t('This activity is not yet publicly visible because is waiting for administrator approval')))])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.activity.translations[_vm.language]) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-sm-12 m-t-4"
  }, [_c('ActivityImages')], 1), _vm._v(" "), _c('div', {
    staticClass: "m-t-4 calendarSide col-md-4"
  }, [_c('ActivityCalendar', {
    attrs: {
      "activityId": _vm.activity.id
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card contactUsCard"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.t('Need help?')))]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("\n              " + _vm._s(_vm.t('If you would like some help or advice for your next tour, feel free to contact us.')) + "\n              ")]), _vm._m(0), _vm._v(" "), _vm._m(1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 m-t-2"
  }, [_c('div', {
    attrs: {
      "id": "activityDescription"
    }
  }, [(_vm.activity.translations[_vm.language]) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('ActivityDescription'), _vm._v(" "), _c('ActivityExtraInfo')], 1)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-2"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('ActivityMap')], 1)])]) : _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('ActivityWithoutTranslation')], 1)])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "phoneBlock"
  }, [_c('i', {
    staticClass: "icon fa fa-phone"
  }), _vm._v(" "), _c('span', {
    staticClass: "phone"
  }, [_vm._v("+351 000 000 000")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "emailBlock"
  }, [_c('i', {
    staticClass: "icon fa fa-envelope"
  }), _vm._v(" "), _c('span', {
    staticClass: "email"
  }, [_vm._v("mail@example.com")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-acec3b56", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-acec3b56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activity/Activity.vue
// module id = 798
// module chunks = 3